export default "__VITE_ASSET__uFWhVYYe__"